var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlphabet = function SvgAlphabet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.823 1.172c-.709-1.563-2.937-1.563-3.646 0L.09 14.594a.994.994 0 0 0 .5 1.318 1 1 0 0 0 1.322-.498l1.97-4.344h8.237l1.97 4.344c.228.501.82.724 1.324.498a.994.994 0 0 0 .5-1.318zM11.21 9.07 8 1.991l-3.211 7.08z",
    clipRule: "evenodd"
  })));
};
export default SvgAlphabet;